module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p1-f7b3c6a8383edefea98c0bcbe2137aa6.png";